import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
// import store from '../store'
import { getToken } from './auth'

// create an axios instance
const service = axios.create({
  baseURL: process.env.APP_API_URL, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 50000 // request timeout
})


// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent

    // if (store.getters.token) {
    //   // let each request carry token
    //   // ['X-Token'] is a custom headers key
    //   // please modify it according to the actual situation
    //   config.headers['X-Token'] = getToken()
    // }
    return config
  },
  error => {
    // do something with request error
    // console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    // console.log('res---------------',response,response);
    if(response.status === 200){
      // console.log('200,200-----response.headers',response.headers);
      var str = response.headers.jumpurl;
      if(str && str.indexOf("http")>=0){
        window.location.href = str;
      }else if(str && str !== '' && str.length > 0){
        let jumpurl = window.location.protocol+"//"+window.location.host+str;
        window.location.href = jumpurl;
      }
    }
    return response.data //正常返回
  },
  error => {
    // console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    if(error.response && error.response.status === 302){
      // alert("302")
      // console.log('302,302-----error',error);
      // console.log('302,302-----error.response',error.response);
      // console.log('302,302-----error.response.headers',error.response.headers);
      // console.log('302,302-----error.headers',error.headers);
      var str = error.response.headers.jumpurl;
      // var str = '/login';
      if(str && str.indexOf("http")>=0){
        window.location.href = str;
      }else if(str && str.length > 0){
        let jumpurl = window.location.protocol+"//"+window.location.host+str;
        window.location.href = jumpurl;
      }else{
        let jumpurl = window.location.protocol+"//"+window.location.host+"/";
        window.location.href = jumpurl;
      }
    }
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js